import Bg from "./components/Bg";
import Header from "./components/Header";
import Hero from "./pages/Hero";
import Resume from "./pages/Resume";
import Work from "./pages/Work";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Uiux from "./pages/Uiux";
import Frontend from "./pages/Frontend";
import Design from "./pages/Design";

function App() {
  return (
    <>
      <Router>
        <Bg />
        <Header />
        <Routes>
          <Route exact path="/" element={<Hero />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/work" element={<Work />} />

          <Route path="/work/uiuxdesign" element={<Uiux />} />
          <Route path="/work/frontend" element={<Frontend />} />
          <Route path="/work/graphicdesign" element={<Design />} />
        </Routes>
      </Router>

    </>

  );
}

export default App;
